import * as React from 'react'
import { useRouter } from 'next/router'
import * as Auth from 'contexts/authentication'
import Client from './'

const { client } = Client

export function useDeleteSubmission() {
    const { locale } = useRouter()
    const { getAccessTokenSilently } = Auth.useAuth()

    return React.useCallback(
        id => {
            const path = [locale, 'submissions', id]

            return client.delete(path, getAccessTokenSilently)
        },
        [locale, getAccessTokenSilently]
    )
}

export function useUndoDeleteSubmission() {
    const { locale } = useRouter()
    const { getAccessTokenSilently } = Auth.useAuth()

    return React.useCallback(
        id => {
            const path = [locale, 'submissions', id, 'undelete']

            return client.post(path, null, getAccessTokenSilently)
        },
        [locale, getAccessTokenSilently]
    )
}

export function useSaveSubmission() {
    const { locale } = useRouter()
    const { getAccessTokenSilently } = Auth.useAuth()

    return React.useCallback(
        data => {
            const { submissionID } = data
            const path = [locale, 'submissions', submissionID]
            const save = submissionID ? client.put : client.post

            return save.call(client, path, data, getAccessTokenSilently)
        },
        [locale, getAccessTokenSilently]
    )
}

export function usePostImages() {
    const { locale } = useRouter()

    return React.useCallback(
        (...images) => {
            const path = [locale, 'images']

            images = images.flat()

            return client.post(path, { images })
        },
        [locale]
    )
}

export function uploadImage(url, file) {
    return fetch(url, {
        method: 'PUT',
        body: file,
        headers: {
            'content-type': file.type,
        },
    })
}
